import { getSrcSetForLazy } from '../utils/getSrcSetForLazy';
import { getImgSizesString } from '../utils/getImgSizesString';
import { dlDispatchAmplEvent } from '../events/dl.dispatchAmplEvent';
const { create, mount } = window.vNode;
void (async () => {
    const section = document.querySelector('.product__recently-viewed_section');
    if (section === null)
        return;
    const itemsContainer = section.querySelector('[data-slider]');
    if (itemsContainer === null)
        return;
    const { sku, url, originalTitle, images } = window.ppData;
    const imagesOfFirstLayout = Object.values(images)[0];
    const currentItem = {
        sku,
        url,
        img: (imagesOfFirstLayout['3d']?.auto?.length ?? 0) > 0
            ? imagesOfFirstLayout['3d'].auto
            : imagesOfFirstLayout.rooms[0].url,
        title: originalTitle
    };
    try {
        const iDBCache = await import('../js/iDBCache').then(async ({ default: iDBCache }) => iDBCache);
        const cache = await iDBCache('pp_rv', { lifetime: { d: 30 } });
        const cachedItems = await cache.getAllEntries().then(items => {
            return items.filter(({ key }) => key !== sku);
        });
        if (cachedItems.length > 10) {
            const itemForRemove = cachedItems.pop();
            itemForRemove !== undefined && cache.deleteValue(itemForRemove.key);
        }
        cache.setValue(sku, currentItem);
        if (cachedItems.length < 1) {
            section.remove();
            return;
        }
        itemsContainer.innerHTML = '';
        cachedItems.forEach(({ value: { url, img, title, sku } }) => {
            mount({
                vNode: create('div', {
                    class: 'pos:r hover-t:bxsh:2',
                    'data-slider-item': ''
                }, [
                    create('a', {
                        class: 'pos:a z:1 t:0 l:0 h:100p w:100p',
                        href: url,
                        events: {
                            click: () => {
                                dlDispatchAmplEvent('PP - Recently Viewed click');
                            }
                        }
                    }),
                    create('div', {
                        class: 'image-wrapper hover-bt:bxsh:2'
                    }, create('img', {
                        class: 'skeleton',
                        loading: 'lazy',
                        sizes: getImgSizesString({
                            sm: 'calc(41.667vw - 0.7292rem)',
                            md: 'calc(25vw - 0.4375rem)',
                            xl: 'calc(18.9404vw - 0.35rem)',
                            xxl: '17.75rem'
                        }),
                        srcset: getSrcSetForLazy(img, 720),
                        src: img,
                        alt: title
                    })),
                    create('div', {
                        class: 'mt:10 fz:12 fz:14:xl-up'
                    }, create('span', {
                        class: 'd:block fw:700 text:ellipsis'
                    }, title))
                ]),
                container: itemsContainer
            });
        });
        section.querySelector('slider-component')?.update();
    }
    catch (e) {
        section.remove();
    }
})();
